// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WwwRouteRouteImport } from './routes/www/route'
import { Route as PortalIdRouteRouteImport } from './routes/$portalId/route'
import { Route as WwwIndexRouteImport } from './routes/www/index'
import { Route as WwwTransparencyRouteImport } from './routes/www/transparency'
import { Route as WwwSelectionCriteriaRouteImport } from './routes/www/selection-criteria'
import { Route as WwwRoundUpRouteImport } from './routes/www/round-up'
import { Route as WwwPrivacyPolicyRouteImport } from './routes/www/privacy-policy'
import { Route as WwwLiveCounterRouteImport } from './routes/www/live-counter'
import { Route as WwwLegalDisclaimerRouteImport } from './routes/www/legal-disclaimer'
import { Route as WwwDemoAnimatedCounterRouteImport } from './routes/www/demo-animated-counter'
import { Route as WwwCookiesRouteImport } from './routes/www/cookies'
import { Route as WwwContactRouteImport } from './routes/www/contact'
import { Route as WwwAboutUsRouteImport } from './routes/www/about-us'
import { Route as WwwSplatRouteImport } from './routes/www/$'
import { Route as WwwDotinternalRouteRouteImport } from './routes/www/[.]internal/route'
import { Route as PortalIdIndexRouteImport } from './routes/$portalId/index'
import { Route as PortalIdTermsRouteImport } from './routes/$portalId/terms'
import { Route as PortalIdPrivacyRouteImport } from './routes/$portalId/privacy'
import { Route as WwwCaArrodonimentSolidariRouteImport } from './routes/www/ca/arrodoniment-solidari'
import { Route as WwwDotinternalToastRouteImport } from './routes/www/[.]internal/toast'
import { Route as WwwDotinternalArchitectureRouteImport } from './routes/www/[.]internal/architecture'
import { Route as PortalIdCampaignIdIndexRouteImport } from './routes/$portalId/$campaignId.index'
import { Route as PortalIdCampaignIdDonateRouteImport } from './routes/$portalId/$campaignId.donate'
import { Route as PortalIdCampaignIdDonateIndexRouteImport } from './routes/$portalId/$campaignId.donate.index'
import { Route as PortalIdCampaignIdDonateThanksRouteImport } from './routes/$portalId/$campaignId.donate.thanks'
import { Route as PortalIdCampaignIdDonateDetailsRouteImport } from './routes/$portalId/$campaignId.donate.details'
import { Route as PortalIdCampaignIdDonateCheckoutRouteImport } from './routes/$portalId/$campaignId.donate.checkout'

const WwwRouteRoute = WwwRouteRouteImport.update({
            id: '/www',path: '/www',getParentRoute: () => rootRouteImport
          })
const PortalIdRouteRoute = PortalIdRouteRouteImport.update({
            id: '/$portalId',path: '/$portalId',getParentRoute: () => rootRouteImport
          })
const WwwIndexRoute = WwwIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WwwRouteRoute
          })
const WwwTransparencyRoute = WwwTransparencyRouteImport.update({
            id: '/transparency',path: '/transparency',getParentRoute: () => WwwRouteRoute
          })
const WwwSelectionCriteriaRoute = WwwSelectionCriteriaRouteImport.update({
            id: '/selection-criteria',path: '/selection-criteria',getParentRoute: () => WwwRouteRoute
          })
const WwwRoundUpRoute = WwwRoundUpRouteImport.update({
            id: '/round-up',path: '/round-up',getParentRoute: () => WwwRouteRoute
          })
const WwwPrivacyPolicyRoute = WwwPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => WwwRouteRoute
          })
const WwwLiveCounterRoute = WwwLiveCounterRouteImport.update({
            id: '/live-counter',path: '/live-counter',getParentRoute: () => WwwRouteRoute
          })
const WwwLegalDisclaimerRoute = WwwLegalDisclaimerRouteImport.update({
            id: '/legal-disclaimer',path: '/legal-disclaimer',getParentRoute: () => WwwRouteRoute
          })
const WwwDemoAnimatedCounterRoute = WwwDemoAnimatedCounterRouteImport.update({
            id: '/demo-animated-counter',path: '/demo-animated-counter',getParentRoute: () => WwwRouteRoute
          })
const WwwCookiesRoute = WwwCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => WwwRouteRoute
          })
const WwwContactRoute = WwwContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => WwwRouteRoute
          })
const WwwAboutUsRoute = WwwAboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => WwwRouteRoute
          })
const WwwSplatRoute = WwwSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => WwwRouteRoute
          })
const WwwDotinternalRouteRoute = WwwDotinternalRouteRouteImport.update({
            id: '/.internal',path: '/.internal',getParentRoute: () => WwwRouteRoute
          })
const PortalIdIndexRoute = PortalIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalIdRouteRoute
          })
const PortalIdTermsRoute = PortalIdTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => PortalIdRouteRoute
          })
const PortalIdPrivacyRoute = PortalIdPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PortalIdRouteRoute
          })
const WwwCaArrodonimentSolidariRoute = WwwCaArrodonimentSolidariRouteImport.update({
            id: '/ca/arrodoniment-solidari',path: '/ca/arrodoniment-solidari',getParentRoute: () => WwwRouteRoute
          })
const WwwDotinternalToastRoute = WwwDotinternalToastRouteImport.update({
            id: '/toast',path: '/toast',getParentRoute: () => WwwDotinternalRouteRoute
          })
const WwwDotinternalArchitectureRoute = WwwDotinternalArchitectureRouteImport.update({
            id: '/architecture',path: '/architecture',getParentRoute: () => WwwDotinternalRouteRoute
          })
const PortalIdCampaignIdIndexRoute = PortalIdCampaignIdIndexRouteImport.update({
            id: '/$campaignId/',path: '/$campaignId/',getParentRoute: () => PortalIdRouteRoute
          })
const PortalIdCampaignIdDonateRoute = PortalIdCampaignIdDonateRouteImport.update({
            id: '/$campaignId/donate',path: '/$campaignId/donate',getParentRoute: () => PortalIdRouteRoute
          })
const PortalIdCampaignIdDonateIndexRoute = PortalIdCampaignIdDonateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalIdCampaignIdDonateRoute
          })
const PortalIdCampaignIdDonateThanksRoute = PortalIdCampaignIdDonateThanksRouteImport.update({
            id: '/thanks',path: '/thanks',getParentRoute: () => PortalIdCampaignIdDonateRoute
          })
const PortalIdCampaignIdDonateDetailsRoute = PortalIdCampaignIdDonateDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => PortalIdCampaignIdDonateRoute
          })
const PortalIdCampaignIdDonateCheckoutRoute = PortalIdCampaignIdDonateCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => PortalIdCampaignIdDonateRoute
          })





const PortalIdCampaignIdDonateRouteChildren = {
  PortalIdCampaignIdDonateCheckoutRoute: PortalIdCampaignIdDonateCheckoutRoute,PortalIdCampaignIdDonateDetailsRoute: PortalIdCampaignIdDonateDetailsRoute,PortalIdCampaignIdDonateThanksRoute: PortalIdCampaignIdDonateThanksRoute,PortalIdCampaignIdDonateIndexRoute: PortalIdCampaignIdDonateIndexRoute
}

const PortalIdCampaignIdDonateRouteWithChildren = PortalIdCampaignIdDonateRoute._addFileChildren(PortalIdCampaignIdDonateRouteChildren)



const PortalIdRouteRouteChildren = {
  PortalIdPrivacyRoute: PortalIdPrivacyRoute,PortalIdTermsRoute: PortalIdTermsRoute,PortalIdIndexRoute: PortalIdIndexRoute,PortalIdCampaignIdDonateRoute: PortalIdCampaignIdDonateRouteWithChildren,PortalIdCampaignIdIndexRoute: PortalIdCampaignIdIndexRoute
}

const PortalIdRouteRouteWithChildren = PortalIdRouteRoute._addFileChildren(PortalIdRouteRouteChildren)




const WwwDotinternalRouteRouteChildren = {
  WwwDotinternalArchitectureRoute: WwwDotinternalArchitectureRoute,WwwDotinternalToastRoute: WwwDotinternalToastRoute
}

const WwwDotinternalRouteRouteWithChildren = WwwDotinternalRouteRoute._addFileChildren(WwwDotinternalRouteRouteChildren)



const WwwRouteRouteChildren = {
  WwwDotinternalRouteRoute: WwwDotinternalRouteRouteWithChildren,WwwSplatRoute: WwwSplatRoute,WwwAboutUsRoute: WwwAboutUsRoute,WwwContactRoute: WwwContactRoute,WwwCookiesRoute: WwwCookiesRoute,WwwDemoAnimatedCounterRoute: WwwDemoAnimatedCounterRoute,WwwLegalDisclaimerRoute: WwwLegalDisclaimerRoute,WwwLiveCounterRoute: WwwLiveCounterRoute,WwwPrivacyPolicyRoute: WwwPrivacyPolicyRoute,WwwRoundUpRoute: WwwRoundUpRoute,WwwSelectionCriteriaRoute: WwwSelectionCriteriaRoute,WwwTransparencyRoute: WwwTransparencyRoute,WwwIndexRoute: WwwIndexRoute,WwwCaArrodonimentSolidariRoute: WwwCaArrodonimentSolidariRoute
}

const WwwRouteRouteWithChildren = WwwRouteRoute._addFileChildren(WwwRouteRouteChildren)

const rootRouteChildren = {
  PortalIdRouteRoute: PortalIdRouteRouteWithChildren,WwwRouteRoute: WwwRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)